import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import {
	AccordionContent,
	AccordionIndicator,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/Accordion";
import { RichTextRenderer } from "@/components/ui/RichText";
import type { BlokAccordionItem } from "@/storyblok";

export const AccordionItemBlok = ({
	blok,
	preview,
}: BlokProps<BlokAccordionItem>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<AccordionItem>
				<AccordionTrigger>
					{blok.title}
					<AccordionIndicator />
				</AccordionTrigger>
				<AccordionContent>
					<RichTextRenderer blok={blok.content ?? ""} preview={preview} />
				</AccordionContent>
			</AccordionItem>
		</BlokWrap>
	);
};
